import { Link } from "react-router-dom";

const SpotlightCard = ({ 
  title, 
  description, 
  image, 
  href, 
  className = "",
  isExternal = false 
}) => {
  const CardContent = () => (
    <div className="group relative overflow-hidden rounded-2xl shadow-lg transition-all duration-500 hover:shadow-2xl hover:-translate-y-2">
      {/* Background Image */}
      <div className="aspect-[4/3] relative overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
          style={{ backgroundImage: `url(${image})` }}
        />
        
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
        
        {/* Spotlight effect */}
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
        <div className="transform transition-transform duration-500 group-hover:translate-y-[-8px]">
          <h3 className="text-xl font-bold mb-2 group-hover:text-white/90 transition-colors duration-300">
            {title}
          </h3>
          
          <p className="text-white/85 leading-relaxed mb-4 group-hover:text-white/95 transition-colors duration-300">
            {description}
          </p>
          
          {/* CTA Button */}
          <div className="inline-flex items-center gap-2 text-sm font-medium bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg hover:bg-white/20 transition-all duration-300 group-hover:bg-deep-green group-hover:text-white">
            <span>Learn More</span>
            <svg 
              className="w-4 h-4 transform transition-transform duration-300 group-hover:translate-x-1" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>

      {/* Border glow effect */}
      <div className="absolute inset-0 rounded-2xl border-2 border-deep-green/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    </div>
  );

  if (isExternal) {
    return (
      <a href={href} className={`block ${className}`} target="_blank" rel="noopener noreferrer">
        <CardContent />
      </a>
    );
  }

  return (
    <Link to={href} className={`block ${className}`}>
      <CardContent />
    </Link>
  );
};

export default SpotlightCard;
